import { useEffect, useState } from 'react';
import axios from 'axios';
import { Star } from 'lucide-react';
import { toast } from 'sonner';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const LEVELS = { 1: 'Kötü', 2: 'Zayıf', 3: 'Orta', 4: 'İyi', 5: 'Çok İyi' };
export const DEFAULT_COLORS = { 1: '#dc2626', 2: '#ea580c', 3: '#facc15', 4: '#16a34a', 5: '#d4a017' };
let colors = DEFAULT_COLORS;
let loading = null;
const subs = new Set();
// Yıldız renkleri tek yerden (Ayarlar) gelir; tüm yıldızlar aboneliğe göre güncellenir
export const setStarColors = (c) => { colors = { ...DEFAULT_COLORS, ...c }; subs.forEach(f => f()); };
const loadColors = () => {
  if (!loading) loading = axios.get(`${API}/five-star/colors`).then(r => setStarColors(r.data.colors)).catch(() => { loading = null; });
  return loading;
};
export const useStarColors = () => {
  const [, tick] = useState(0);
  useEffect(() => { const f = () => tick(x => x + 1); subs.add(f); loadColors(); return () => subs.delete(f); }, []);
  return colors;
};
export const level = (v) => Math.min(5, Math.max(1, Math.round(v)));

export const StarInput = ({ value, onChange, testId, compact = false }) => {
  const c = useStarColors();
  return (
  <div className="flex items-center gap-1" data-testid={testId}>
    {[1, 2, 3, 4, 5].map(n => (
      <button key={n} type="button" onClick={() => onChange(n === value ? undefined : n)} title={n === value ? 'Puanı kaldır' : `${n} - ${LEVELS[n]}`} className="rounded p-0.5 transition-transform hover:scale-110" data-testid={`${testId}-${n}`}>
        <Star className={`${compact ? 'h-5 w-5' : 'h-6 w-6'} ${n <= (value || 0) ? 'fill-current' : 'text-slate-300'}`} style={n <= (value || 0) ? { color: c[value] } : undefined} />
      </button>
    ))}
    {!compact && <span className={`ml-1 w-14 text-xs font-medium ${value ? '' : 'text-slate-400'}`} style={value ? { color: c[value] } : undefined}>{value ? LEVELS[value] : 'Puan yok'}</span>}
  </div>
  );
};

export const StarScore = ({ value, jobs, lowData, size = 'sm', testId }) => {
  const c = useStarColors();
  if (value == null) return <span className="text-xs text-slate-400" data-testid={testId}>Denetim yok</span>;
  const r = level(value);
  return (
    <span className="inline-flex items-center gap-1.5 whitespace-nowrap" data-testid={testId}>
      <span className="inline-flex">{[1, 2, 3, 4, 5].map(n => <Star key={n} className={`${size === 'lg' ? 'h-5 w-5' : 'h-3.5 w-3.5'} ${n <= r ? 'fill-current' : 'text-slate-300'}`} style={n <= r ? { color: c[r] } : undefined} />)}</span>
      <b className="text-sm" style={{ color: c[r] }}>{Number(value).toFixed(2)}</b>
      {jobs != null && <span className="text-xs text-slate-500">({jobs} iş)</span>}
      {lowData && <span className="rounded bg-slate-100 px-1.5 py-0.5 text-[10px] font-semibold text-slate-500">Az veri</span>}
    </span>
  );
};

export const openAuditPdf = async (id) => {
  try {
    const r = await axios.get(`${API}/five-star/audits/${id}/pdf`, { responseType: 'blob' });
    window.open(URL.createObjectURL(r.data), '_blank');
  } catch { toast.error('PDF açılamadı'); }
};

export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString('tr-TR') : '-');
